import React from 'react';
import PropTypes from 'prop-types';

import TextEditorToolEditableValue from './TextEditorToolEditableValue';
import DropdownTextEditorToolValue from './DropdownTextEditorToolValue';

const DropdownTextEditorToolEditableValue = ({
  isOpened,
  value,
  onToggle,
  maxValue,
  minValue,
  onChange,
}) => (
  <div>
    {isOpened && (
      <TextEditorToolEditableValue
        value={value}
        maxValue={maxValue}
        minValue={minValue}
        onChange={onChange}
        onToggle={onToggle}
      />
    )}
    <DropdownTextEditorToolValue value={value} visible={!isOpened} />
  </div>
);

DropdownTextEditorToolEditableValue.propTypes = {
  isOpened: PropTypes.bool,
  value: PropTypes.number,
  onToggle: PropTypes.func,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  onChange: PropTypes.func,
};

export default DropdownTextEditorToolEditableValue;
